import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';

import BusinessInfo from './business-info';
import VerificationDocumentation from './vetting-document';
import LandlordStatus from './landlord-status';
import useStyles from '../style';
import { useTranslation } from 'react-i18next';

const LandlordVerification = ({
  landlord = {},
  updateLandlordLoading = false,
  getLandlord,
  updateLandlord,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Row>
      <Col
        span={24}
        className={classes.cardContainer}
        id={t('cms.landlord.verification.business_info')}
      >
        <BusinessInfo
          landlord={landlord}
          updateLandlordLoading={updateLandlordLoading}
          getLandlord={getLandlord}
          updateLandlord={updateLandlord}
        />
      </Col>

      <Col
        span={24}
        className={classes.cardContainer}
        id={t('cms.landlord.verification.vetting_documentation')}
      >
        <VerificationDocumentation landlord={landlord} getLandlord={getLandlord} />
      </Col>

      <If condition={landlord.landlordStatusLog.length > 0}>
        <Col span={24} id={t('cms.landlord.verification.landlord_status')}>
          <LandlordStatus landlordStatusLog={landlord.landlordStatusLog ?? []} />
        </Col>
      </If>
    </Row>
  );
};

LandlordVerification.propTypes = {
  landlord: PropTypes.object.isRequired,
  updateLandlordLoading: PropTypes.bool.isRequired,
  getLandlord: PropTypes.func.isRequired,
  updateLandlord: PropTypes.func.isRequired,
};

export default LandlordVerification;
